import React, { useState } from "react";
import '../Styles/NavBar.css'
import { FaShoppingCart, FaAlignJustify,  FaUserAlt } from "react-icons/fa";
import {  Outlet, Link } from "react-router-dom";
import Hero from "./Hero";
import Customizations from "../components/Customizations";

import Footer from "./Footer";



export default function Layout() {

    const [menu, setMenu] = useState("art");
    const [toClothing, setToClothing] = useState('clothing');
    const [toJewelry, setToJewelry] = useState('jewelry');
    const [toEverything, setToEverything] = useState('EverythingElse');
   

    return (
        <>
        <div className="Navbar-home p-4">
            <nav className="navbar navbar-expand-lg bg-body-tertiary ">
                <div className="menu-btn p-2">
                <div className="dropdown">
         <button className="btn menu-drop dropdown-toggle pb-2" type="button"         data-bs-toggle="dropdown" aria-expanded="false">
             <FaAlignJustify  fontSize={20} />
            </button>
         <ul className="dropdown-menu">
             <li onClick={() => {setMenu("art")}} className="dropdown-item" >
                <Link to='/ArtProducts'className="link" >
                Art
                </Link>{menu === "art" ? <hr/> : <></>}
             </li>

            <li onClick={() => {setToClothing("clothing")}} className="dropdown-item"  >
               <Link to= '/Clothing'className="link">
                Clothing & Accessories
               </Link> 
                {toClothing === "clothing" ? <hr/> : <></>}
            </li>

            <li onClick={() => {setToJewelry("jewelry")}} className="dropdown-item"> 
               <Link to='/Jewelry'className="link" >
                Jewelry 
                </Link>
                {toJewelry === "jewelry" ? <hr/> : <></>}
            </li>

             <li onClick={() => {setToEverything("EverythingElse")}} className="dropdown-item" >
                <Link to='/EverythingElse' className="link">
                Everything else!
                </Link>
                {toEverything === "EverythingElse" ? <hr/> : <></> } </li>
             </ul>
            </div>
                
                </div>
  <div className="container-fluid justify-content-center">
    <Link to >
 <img src="https://s3.amazonaws.com/shecodesio-production/uploads/files/000/140/288/original/MM_logo.png?1724187283" width={340} alt="main logo"/></Link>
   </div>
      <ul className="navbar-nav  me-auto mb-2 mb-lg-0 d-flex">
        <li className="nav-item">
           <Link to='/Userlogin'  className="nav-link" aria-label="Userlogin" title="login" ><FaUserAlt />
           </Link>
            
         </li>    
        <li className="nav-item">
        <Link to='/Checkout' className="nav-link" alt="Cart" aria-label="Cart" title="Cart"><FaShoppingCart /></Link>
        </li>
        </ul> 
        </nav>
        <div className="header-box mt-4">
        <form className="form-search d-flex" name="homeSearch" role="search" id="input-search">
            <label>
        <input className="input-search form-control me-2 py-2 px-3" type="search" placeholder="Search for all your goodies!" name="search"id="search" ></input>
        </label>
        <button className="search-button" type="submit">Search</button>
                </form>
        </div>
        </div>
        <Hero />
        <Customizations />
       
       
        <Footer />
        <Outlet />
        </>
    )
};
